import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  getActiveListingPage,
  getPageHeaderTitleForForSearchActiveListingPage,
  getPageHeaderTitleForActiveSegmentListingPage
} from '../../reduck/selectors';


const StyledH1 = styled.h1`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.primary.default};
`;

const HeaderTitle = (props) => (
  <StyledH1 className={'pageTitle'}>{props.pageHeaderTitle}</StyledH1>
);

HeaderTitle.displayName = 'HeaderTitle';

HeaderTitle.propTypes = {
  pageHeaderTitle: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  pageHeaderTitle: getActiveListingPage(state).searchListingPage
    ? getPageHeaderTitleForForSearchActiveListingPage(state)
    : getPageHeaderTitleForActiveSegmentListingPage(state)
});

export default connect(mapStateToProps)(HeaderTitle);
